import { useTranslation } from 'react-i18next';
import { countries as enCountries } from '../i18n/ui/en/countries';
import { countries as esCountries } from '../i18n/ui/es/countries';

export const useCountryTranslation = () => {
    const { i18n } = useTranslation();

    const getCountryName = (countryCode: string): string => {
        const upperCode = countryCode.toUpperCase();

        // Seleccionar el diccionario según el idioma actual
        const countriesDict = i18n.language === 'es' ? esCountries : enCountries;

        // Buscar el país en el diccionario
        const countryName = countriesDict[upperCode as keyof typeof countriesDict];

        // Retornar el nombre del país o el código si no se encuentra
        return countryName || upperCode;
    };

    return {
        getCountryName
    };
}; 